import { render, staticRenderFns } from "./SelectIsSelectedItem.vue?vue&type=template&id=ec83d7c2&"
import script from "./SelectIsSelectedItem.vue?vue&type=script&lang=js&"
export * from "./SelectIsSelectedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports